import * as React from 'react';
import {Outlet, useNavigate} from 'react-router-dom';
import {AppBar, Box, IconButton, Toolbar, Typography} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import {Confirmation} from '../utils';
import NavigationActions from '../navigationActions';
import {CONST, TokenValidator} from '../../utils';

const USER_ROLE = 2;
const ADMIN_ROLE = 4;

export default function Holder() {
    const nav = useNavigate();
    const [logged, setLogged] = React.useState(false);
    const [logoutOpen, setLogoutOpen] = React.useState(false);
    const validate = React.useCallback(async token => {
        if (!token || !(await TokenValidator.ValidTokenDate(token))) return false;
        const decoded = await TokenValidator.SimplifyToken(token);
        const roles = Number(decoded.roles);
        return (roles & USER_ROLE) === USER_ROLE || (roles & ADMIN_ROLE) === ADMIN_ROLE;
    }, []);
    React.useEffect(() => { TokenValidator.GetStaffUser().then(async token => {
        const allowed = await validate(token); setLogged(allowed); if (!allowed) nav('/pmlabeling', {replace: true});
    }); }, [nav, validate]);
    const logout = () => { localStorage.removeItem(CONST.STORAGE_KEYS.STAFF_LOGIN); setLogoutOpen(false); setLogged(false); nav('/pmlabeling', {replace: true}); };
    return <Box sx={{minHeight: '100vh'}}><AppBar position='static'><Toolbar><NavigationActions />
        <Typography variant='h6' sx={{flexGrow: 1}}>PM LABELING</Typography>
        {logged && <IconButton color='inherit' aria-label='Log out' onClick={() => setLogoutOpen(true)}><LogoutIcon /></IconButton>}
    </Toolbar></AppBar><Confirmation open={logoutOpen} onClose={() => setLogoutOpen(false)} onConfirm={logout}
        title='Log Out' msg='Confirm logout from PM Labeling' /><Outlet context={{Login: {didLogin: setLogged, validate}}} /></Box>;
}
